export const notifications = {
    COMPANY_ADDED: {
        type: 'success',
        title: '',
        body: 'Company saved',
    },
    COMPANY_ALREADY_ADDED: {
        type: 'success',
        title: '',
        body: 'Company already saved',
    },
    COMPANY_REMOVED: {
        type: 'success',
        title: '',
        body: 'Company removed',
    },

    WORKSPACE_LOADED: {
        type: 'success',
        title: 'Project loaded',
        body: null,
    },

    GENERIC_ERROR: {
        type: 'error',
        title: 'Unable to perform your action',
        body: null,
    },

    GENERIC_LOADING_ERROR: {
        type: 'error',
        title: 'Unable to load information',
        body: null,
    },

    GENERIC_SUCCESS: {
        type: 'success',
        title: 'All is well',
        body: null,
    },

    getLoadingError(resource) {
        let notification = this.GENERIC_ERROR;
        notification.title = `Unable to load the resource: "${resource}"`;
        notification.body = "Please, reload the current page."

        return notification;
    },

    getCompanyAddedNotification(name, channelLabel = null) {
        let notification = this.COMPANY_ADDED;
        notification.title = name;

        if (channelLabel !== null) {
            notification.body = 'Company saved into your <span class="underline ">' + channelLabel + '</span> list';
        }

        return notification;
    },

    getCompanyAlreadyAddedNotification(name) {
        let notification = this.COMPANY_ALREADY_ADDED;
        notification.title = name;

        return notification;
    },

    getCompanyRemovedNotification(name) {
        let notification = this.COMPANY_REMOVED;
        notification.title = name;

        return notification;
    },

    getCopyWorkspaceErrorNotification() {
        return {
            type: 'error',
            title: `Failed to copy the workspace`,
            body: 'An error occurred during the copy of the workspace',
        };
    },

    getCopiedWorkspaceNotification(name) {
        return {
            type: 'success',
            title: `workspace created`,
            body: 'Your new workspace has been added to your workspace list',
        };
    },

    getCopyCompanyErrorNotification() {
        return {
            type: 'error',
            title: `Failed to copy the company`,
            body: 'An error occurred during the copy of the company',
        };
    },

    getCopyCompanyAlreadyAddedErrorNotification(companyName) {
        return {
            type: 'warning',
            title: `${companyName}`,
            body: 'The company to be copied already exists in the destination',
        };
    },

    getCopiedCompanyNotification(workspaceName, companyName, channelName) {
        return {
            type: 'success',
            title: `Company copied`,
            body: `'${companyName}' has been added to your workspace '${workspaceName}' into the list '${channelName}'`,
        };
    },

    getCopiedWorkspaceErrorNotification(name) {
        return {
            type: 'error',
            title: `Failed to copy the workspace`,
            body: 'An error occurred during the copy of the workspace',
        };
    },

    getCreatedWorkspaceNotification(name) {
        return {
            type: 'success',
            title: 'Project created',
            body: 'Your new project has been added to your project list',
        };
    },
    getCreatedWorkspaceErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to create a project',
            body: 'An error occurred during the creation of your new project',
        };
    },

    getEditedWorkspaceNotification(name) {
        return {
            type: 'success',
            title: 'Saved project updates',
            body: 'Updates to your project have been saved.',
        };
    },
    getEditedWorkspaceErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to save your project updates',
            body: 'An error occurred during save updates to your project',
        };
    },

    getEditedProfileNotification() {
        return {
            type: 'success',
            title: 'Saved preferences updates',
            body: 'Updates to your preference have been saved.',
        };
    },
    getEditedProfileErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to save your preferences updates',
            body: 'An error occurred during save updates to your preferences',
        };
    },

    getEditedChannelNotification(name) {
        return {
            type: 'success',
            title: 'Saved list updates',
            body: 'Updates to your list have been saved.',
        };
    },
    getEditedChannelErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to save your list updates',
            body: 'An error occurred during save updates to your list',
        };
    },



    getCreatedChannelNotification(name) {
        return {
            type: 'success',
            title: 'New list created',
            body: 'Your new list has been added to your project list',
        };
    },
    getCreatedChannelErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to create a new channel',
            body: 'An error occurred during the creation of your new channel',
        };
    },





    getCreatedInnovationProjectNotification(name) {
        return {
            type: 'success',
            title: 'New innovation project created',
            body: 'Your new innovation project has been added',
        };
    },
    getCreatedInnovationProjectErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to create a new innovation project',
            body: 'An error occurred during the creation of your new innovation project',
        };
    },

    getEditedInnovationProjectNotification(name) {
        return {
            type: 'success',
            title: 'Saved innovation project updates',
            body: 'Updates to your innovation project have been saved.',
        };
    },
    getEditedInnovationProjectErrorNotification(name) {
        return {
            type: 'error',
            title: 'Failed to save your innovation project updates',
            body: 'An error occurred during save updates to your innovation project',
        };
    },


    getErrorNotification(title = null, body = null) {
        return this.getNotification('error', title, body);
    },

    getSuccessNotification(title = null, body = null) {
        return this.getNotification('success', title, body);
    },

    getInfoNotification(title = null, body = null) {
        return this.getNotification('info', title, body);
    },

    getWarnNotification(title = null, body = null) {
        return this.getNotification('warning', title, body);
    },

    getNotification(type = 'success', title = null, body = null) {
        return {
            type: type,
            title: title,
            body: body,
        };
    },
}